<template>
  <span class="scaling-svg-container">
    <svg
      id="Icon_blank"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      class="scaling-svg"
    >
      <g id="Icon_blank-2" data-name="Icon_blank" transform="translate(3 1.5)">
        <path
          id="Shape"
          d="M10.5,15h-9A1.5,1.5,0,0,1,0,13.5V1.5A1.5,1.5,0,0,1,1.5,0H9l3,3V13.5A1.5,1.5,0,0,1,10.5,15ZM2.25,1.5a.751.751,0,0,0-.75.75v10.5a.751.751,0,0,0,.75.75h7.5a.751.751,0,0,0,.751-.75V4.5h-3v-3ZM9,1.5V3h1.5Z"
        />
        <path
          id="Path"
          d="M0,.75A.75.75,0,0,1,.75,0h4.5a.75.75,0,0,1,0,1.5H.75A.75.75,0,0,1,0,.75Z"
          transform="translate(3 6)"
        />
        <path
          id="Path-2"
          data-name="Path"
          d="M0,.75A.75.75,0,0,1,.75,0h3a.75.75,0,0,1,0,1.5h-3A.75.75,0,0,1,0,.75Z"
          transform="translate(3 9)"
        />
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DocumentNonEmptyIcon extends Vue {}
</script>

<style>
</style>
